<section class="account_pay_sec enquiries_sec">
  <div class="custom-tabs">
    <!-- Account Pay Details -->
    <mat-tab-group [@.disabled]="true">
      <!--  Account Pay Details-TAB -->
      <mat-tab>
        <ng-template mat-tab-label>
          Account Pay Details
        </ng-template>
        <!-- TABS-BODY -->
        <section class="tabs-body mt-0 pt-0">
          <div class="mb-20 pr-10" fxLayout="row" fxLayout.xl="row" fxLayout.lg="row" fxLayout.md="row" fxLayout.sm="row"
            fxLayout.xs="column" fxLayoutAlign="start stretch" fxLayoutGap="15px">
            <div fxLayout="column" fxFlex.xl="100" fxFlex.lg="100" fxFlex.md="100" fxFlex.sm="100" fxFlex.xs="100"
              fxFlexFill fxLayoutAlign="end end">
              <button class="btn btn-sm global-btn" mat-button (click)="addAccountPay()">Add Account Pay</button>
            </div>
          </div>
          <!-- TABLE-LISTING -->
          <div fxLayout="row" fxLayout.xl="row" fxLayout.lg="row" fxLayout.md="row" fxLayout.sm="row"
            fxLayout.xs="column" fxLayoutAlign="start stretch" fxLayoutGap="15px">
            <div fxLayout="column" fxFlex="100" fxFlexFill>
              <!-- tables-section -->
              <section class="table_section">
                <div class="custom-sticky-table" fxLayout="column" fxLayoutAlign="start stretch">
                  <perfect-scrollbar>
                    <table mat-table [dataSource]="dataSource" matSort multiTemplateDataRows>
                      <!-- Position Column -->
                      <ng-container matColumnDef="sNo">
                        <th mat-header-cell *matHeaderCellDef>S.No</th>
                        <td mat-cell *matCellDef="let element;let i = dataIndex" data-label="S.No"> {{ i+1 }} </td>
                      </ng-container>
                      <!-- Name Column -->
                      <ng-container matColumnDef="supplier_name">
                        <th mat-header-cell *matHeaderCellDef>Supplier Name</th>
                        <td mat-cell *matCellDef="let element" data-label="Supplier Name">
                          {{element?.supplier?.business_name}}
                        </td>
                      </ng-container>
                      <!-- Bid Price Column -->
                      <ng-container matColumnDef="account_number">
                        <th mat-header-cell *matHeaderCellDef>Account Number</th>
                        <td mat-cell *matCellDef="let element" data-label="Account Number">
                          {{element.account_number}}
                        </td>
                      </ng-container>

                      <!-- Action Column -->
                      <ng-container matColumnDef="action">
                        <th mat-header-cell *matHeaderCellDef>
                          <span class="tab_head"> Action </span>
                        </th>
                        <td mat-cell *matCellDef="let element" data-label="action" (click)="$event.stopPropagation()"
                          (click)="$event.stopPropagation()" style="pointer-events:all;" data-label="Action">
                          <button mat-icon-button [matMenuTriggerFor]="menu">
                            <mat-icon>more_vert</mat-icon>
                          </button>
                          <mat-menu #menu="matMenu" class="table-action-btn">
                            <button type="button" class="view" mat-menu-item
                            (click)="deleteDialog(element)">
                              <img src="../../../../../assets/images/icons//action_icons/view.svg" alt="img">
                              <span> Delete </span>
                            </button>
                            <!--<button type="button" class="delete" mat-menu-item (click)="delete()">
                              <img src="../../../../../assets/images/icons/action_icons/delete.svg" alt="img">
                              <span> Delete </span>
                            </button>-->
                            <!--<button type="button" class="edit" mat-menu-item (click)="sendReplyDialog(element)">
                              <img src="../../../../../assets/images/icons/edit.svg" alt="img">
                              <span> Send Reply </span>
                            </button>-->
                          </mat-menu>
                        </td>
                      </ng-container>

                      <ng-container matColumnDef="loading">
                        <th mat-footer-cell *matFooterCellDef colspan="8">
                          <div class="custom-loader ">
                                <div class="custom-loader custom_logo_loader">
                        <img src='../../../../../images2/loader.gif' alt="img" loading="lazy" />
                      </div>
                          </div>
                        </th>
                      </ng-container>
                      <ng-container matColumnDef="noData">
                        <th mat-footer-cell *matFooterCellDef colspan="8">
                          <div class="no-data empty-img">
                            <!-- EMPTY-STATE -->
                            <img src='../../../../../../../assets/images/empty-imgs/no_account_pay.svg' alt="img" loading="lazy" />
                            <h4 class="no_state_heading">No account pays</h4>
                          </div>
                        </th>
                      </ng-container>
                      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                      <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
                      <tr mat-footer-row *matFooterRowDef="['loading']" [ngClass]="{ hide: dataSource != null }"></tr>
                      <tr mat-footer-row *matFooterRowDef="['noData']" [ngClass]="{hide: !( dataSource != null && dataSource.filteredData.length == 0)
                  }"></tr>
                    </table>
                  </perfect-scrollbar>
                  <!-- TABLE-PAGINATOR -->
                  <div fxLayout="column" fxLayout.lg="column" fxLayout.md="column" fxLayout.sm="column"
                    fxLayout.xs="column" fxFlexFill fxLayoutGap="8px">
                    <mat-paginator [length]="totalElements" [pageSize]="limit.value" (page)="changePage($event)">
                    </mat-paginator>
                  </div>
                </div>
              </section>
            </div>
          </div>
        </section>
      </mat-tab>
      <!--  Account Pay Request-TAB -->
      <mat-tab>
        <ng-template mat-tab-label>
          Account Pay Request
        </ng-template>
        <!-- TABS-BODY -->
        <section class="tabs-body">
          <!-- TABLE-LISTING -->
          <div fxLayout="row" fxLayout.xl="row" fxLayout.lg="row" fxLayout.md="row" fxLayout.sm="row"
            fxLayout.xs="column" fxLayoutAlign="start stretch" fxLayoutGap="15px">
            <div fxLayout="column" fxFlex="100" fxFlexFill>
              <!-- tables-section -->
              <section class="table_section">
                <div class="custom-sticky-table" fxLayout="column" fxLayoutAlign="start stretch">
                  <perfect-scrollbar>
                    <table mat-table [dataSource]="dataSource1" multiTemplateDataRows>
                      <!-- Position Column -->
                      <ng-container matColumnDef="sNo">
                        <th mat-header-cell *matHeaderCellDef>S.No</th>
                        <td mat-cell *matCellDef="let element;let i = dataIndex" data-label="S.No"> {{ i+1 }} </td>
                      </ng-container>
                      <!-- Name Column -->
                      <ng-container matColumnDef="supplier_name">
                        <th mat-header-cell *matHeaderCellDef>Supplier Name</th>
                        <td mat-cell *matCellDef="let element" data-label="Supplier Name">
                          {{element?.supplier?.name}}
                        </td>
                      </ng-container>
                      <!-- Name Column -->
                      <ng-container matColumnDef="name">
                        <th mat-header-cell *matHeaderCellDef> Name </th>
                        <td mat-cell *matCellDef="let element" data-label="Name">
                          {{element.name}}
                        </td>
                      </ng-container>
                      <!-- Email Column -->
                      <ng-container matColumnDef="email">
                        <th mat-header-cell *matHeaderCellDef> Email </th>
                        <td mat-cell *matCellDef="let element" data-label="Email">
                          {{element.email}}
                        </td>
                      </ng-container>
                      <!-- Phone Column -->
                      <ng-container matColumnDef="phone">
                        <th mat-header-cell *matHeaderCellDef> Phone No</th>
                        <td mat-cell *matCellDef="let element" data-label="Phone">
                          {{element.phone}}
                        </td>
                      </ng-container>
                      <ng-container matColumnDef="loading">
                        <th mat-footer-cell *matFooterCellDef colspan="8">
                          <div class="custom-loader ">
                                <div class="custom-loader custom_logo_loader">
                        <img src='../../../../../assets/images2/loader.gif' alt="img" loading="lazy" />
                      </div>
                          </div>
                        </th>
                      </ng-container>
                      <ng-container matColumnDef="noData">
                        <th mat-footer-cell *matFooterCellDef colspan="8">
                          <div class="no-data empty-img">
                            <!-- EMPTY-STATE -->
                            <img src='../../../../../../../assets/images/empty-imgs/no_account_pay.svg' alt="img" loading="lazy" />
                            <h4 class="no_state_heading">No account pays</h4>
                          </div>
                        </th>
                      </ng-container>
                      <tr mat-header-row *matHeaderRowDef="displayedColumns1"></tr>
                      <tr mat-row *matRowDef="let row; columns: displayedColumns1;"></tr>
                      <tr mat-footer-row *matFooterRowDef="['loading']" [ngClass]="{ hide: dataSource1 != null }"></tr>
                      <tr mat-footer-row *matFooterRowDef="['noData']" [ngClass]="{hide: !( dataSource1 != null && dataSource1.filteredData.length == 0)
                  }"></tr>
                    </table>
                  </perfect-scrollbar>
                  <!-- TABLE-PAGINATOR -->
                  <div fxLayout="column" fxLayout.lg="column" fxLayout.md="column" fxLayout.sm="column"
                    fxLayout.xs="column" fxFlexFill fxLayoutGap="8px">
                    <mat-paginator [length]="totalElements1" [pageSize]="limit1.value" (page)="changePage1($event)">
                    </mat-paginator>
                  </div>
                </div>
              </section>
            </div>
          </div>
        </section>
      </mat-tab>
    </mat-tab-group>
  </div>
</section>
